const HamburguerIcon = ({ onHandleOpenMenu , isClosed, shouldAnimate}) => {

  const openIconClass = !isClosed && !shouldAnimate ? " translate-y-1.5 rotate-45" : "";
  const openIconClassSecondary = !isClosed  && !shouldAnimate ? "w-6 sm:w-10 -translate-y-1.5 -rotate-45" : "w-8";


  return (
  <div class="flex  w-full items-center justify-center z-90" role="button" onClick={onHandleOpenMenu}>
                <div class="group flex h-16 sm:h-20 w-16 sm:w-20 cursor-pointer items-center justify-center rounded-3xl bg-white p-2 hover:bg-slate-200">
                  <div class="space-y-2">
                    <span class={`block h-1 w-6 sm:w-10 origin-center rounded-full bg-slate-500 transition-transform ease-in-out ${openIconClass}`}></span>
                    <span class={`block h-1 origin-center rounded-full bg-[#2a8c4a] transition-transform ease-in-out ${openIconClassSecondary}`}></span>
                  </div>
                </div>
              </div>
  )
}

export default HamburguerIcon